import createPledgesPaymentTableHelpers from '../manager/pledges/pledges-payment-table';
import { resetRecurViewDetailsLink } from '../manager/pledges/pledges-recur-payment-modal.js';
import { cleanupBootstrapModalBody } from '../shared/bootstrap-modal-cleanup.js';
import { showAlertMsg } from './member-show-alert-msg.js';

function resetModalFields($modal) {
    $modal.find('#recur_pay_body').empty();
    $modal.find('#pay_member_name, #pay_campaign, #pay_description, #pay_date_pledged, #pay_amount_due, #pay_next_payment, #pay_frequency, #pay_original_duration, #pay_payments_left').text('');
    $modal.find('#pay_next_payment_head').text('Next Payment');
    $modal.find('#frequency_header, #installment_header, #num_left_header, #pay_next_payment_head').show();
    resetRecurViewDetailsLink();
}

export function closeViewRecurModal() {
    const $modal = $('#viewRecurModal');
    resetModalFields($modal);
    $modal.modal('hide');
    cleanupBootstrapModalBody();
}

export function initViewRecurPaymentModal({ routes, csrfToken }) {
    const { mapPaymentsAndTotals, createPaymentsTableElement } = createPledgesPaymentTableHelpers();
    const $modal = $('#viewRecurModal');

    $(document)
        .off('click.viewRecurModal', '[data-action="close-view-recur-modal"]')
        .on('click.viewRecurModal', '[data-action="close-view-recur-modal"]', function (e) {
            e.preventDefault();
            closeViewRecurModal();
        });

    function openViewRecurPayments(recordId, tableName) {
        const $body = $modal.find('#recur_pay_body').empty();
        const url = `${routes.recurringPaymentData}/${encodeURIComponent(recordId)}/${encodeURIComponent(tableName)}/user`;

        const paymentsResult = window.fetchRecurPayments(url, csrfToken);
        if (!paymentsResult[0]) {
            showAlertMsg(paymentsResult[1], 'danger');
            return;
        }
        const { payments, totals } = mapPaymentsAndTotals(paymentsResult[1]);
        $body.append(createPaymentsTableElement(payments, totals, { linkToTransactions: false }));

        const mainModalData = window.getPaymentTopModalData(recordId, tableName, url, csrfToken);
        if (!mainModalData[0]) {
            showAlertMsg(mainModalData[1], 'danger');
            return;
        }
        const mainData = mainModalData[1];
        $modal.find('#frequency_header, #installment_header, #num_left_header, #pay_next_payment_head').hide();
        $modal.find('#pay_member_name').text(mainData.pay_member_name || '');
        $modal.find('#pay_campaign').text(mainData.pay_campaign);
        $modal.find('#pay_description').text(mainData.pay_description);
        $modal.find('#pay_date_pledged').text(mainData.pay_date_pledged);
        $modal.find('#pay_amount_due').text(mainData.pay_amount_due);
        if (mainData.pay_next_payment != null) {
            $modal.find('#pay_next_payment').text(mainData.pay_next_payment);
            $modal.find('#pay_frequency').text(mainData.pay_frequency);
            $modal.find('#pay_next_payment_head, #frequency_header').show();
            $modal.find('#pay_original_duration').text(mainData.pay_original_duration);
            $modal.find('#pay_payments_left').text(mainData.pay_payments_left);
            $modal.find('#installment_header, #num_left_header').show();
        }
        $modal.modal('show');
    }

    return { openViewRecurPayments };
}
